import { render, staticRenderFns } from "./PanelTabs.vue?vue&type=template&id=3a7b230d&scoped=true&"
import script from "./PanelTabs.vue?vue&type=script&lang=js&"
export * from "./PanelTabs.vue?vue&type=script&lang=js&"
import style0 from "./PanelTabs.vue?vue&type=style&index=0&id=3a7b230d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b230d",
  null
  
)

export default component.exports